import $ from 'jquery'
import {lockBody, unlockBody} from "../_utils";

const $menu = $('.main-menu');
const $menuToggle = $('.js-menu-toggle');
const object = vnObject

$menuToggle.on('click', function () {

  if ($menu.hasClass('is-open')) {
    $menuToggle.find('.vn-a-content').html(object.menu)
    $menuToggle.find('.vn-icons').addClass('vn-icons-menu')
    $menuToggle.find('.vn-icons').removeClass('vn-icons-close')

    $menu
        .removeClass('is-open')
        .addClass('is-closing');

    setTimeout(function () {
      $menu.removeClass('is-closing');
    }, 1000);
    unlockBody()
  } else {
    $menuToggle.find('.vn-a-content').html(object.close)
    $menuToggle.find('.vn-icons').addClass('vn-icons-close')
    $menuToggle.find('.vn-icons').removeClass('vn-icons-menu')
    $menu.addClass('is-open');
    lockBody()
  }

});